import { render, staticRenderFns } from "./C4.vue?vue&type=template&id=001986ed"
import script from "./C4.vue?vue&type=script&lang=js"
export * from "./C4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports